/* eslint-disable @typescript-eslint/explicit-function-return-type */
import EmptyState from 'app/components/EmptyState/EmptyState';
import FundingProgressBar from 'app/components/FundingProgressBar/FundingProgressBar';
import MarketplaceCard from 'app/components/MarketplaceCard/MarketplaceCard';
import ShimmeringLoading from 'app/components/ShimmeringLoading/ShimmeringLoading';
import TextLabel from 'app/components/TextLabel/TextLabel';
import {
    IMarketplaceTable,
    marketPlaceDummyData,
    marketplaceListEmptyState,
    BULK_MARKETPLACE_CONFIG
} from 'app/configs/marketplaceList.config';
import { IEmptyState } from 'app/interfaces/empty-state/empty-state.interface';
import { IBulkMarketplaceList, IMarketplaceList } from 'app/interfaces/marketplace/marketplace.interface';
import { ITextLabel } from 'app/interfaces/text-label/textLabel.interface';
import {
    getBulkMarketplaceList,
    getMarketplaceListAction,
    resetMarketplaceFactsheetAction,
    resetMarketplaceListAction
} from 'app/redux/actions/MarketplaceListAction';
import { IPagination } from 'app/redux/reducers/PortofolioReducer';
import { RootState } from 'app/redux/store';
import ROUTER_PATH from 'app/routes/routerPath';
import rupiahCurrencyFormatter from 'app/utils/RupiahPipe';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import './MarketplaceList.scss';
import BulkFundingCard from 'app/components/BulkFundingCard/BulkFundingCard';
import FilterBarComponent from 'app/components/FilterBarComponent/FilterBarComponent';
import { getLoanTypeAction } from 'app/redux/actions/LoanTypeAction';
import { IInputModel } from 'app/interfaces/input/input.interface';

const paginationInit: IPagination = {
    totalData: 0,
    totalPage: 0,
    page: 1,
};

const MarketplaceList = function init(): React.ReactElement {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const marketplaceListState = useSelector((state: RootState) => state.marketplaceListReducer);
    const loanTypeList = useSelector((state: RootState) => state.loanTypeReducer);
    const [page, setPage] = useState(1);
    const [bulkPage] = useState(1);
    const [marketplaceTextLabel, setMarketplaceTextLabel] = useState<IMarketplaceTable[]>([]);
    const [localMarketplaceData] = useState([] as IMarketplaceTable[]);
    const [localBulkList, setLocalBulkList] = useState<IBulkMarketplaceList[]>([]);
    const [localPagination, setPagination] = useState(paginationInit);
    const [localBulkPagination, setBulkPagination] = useState(paginationInit);
    const { marketplaceList, pagination, loading, factsheetBase64, bulkMarketplaceList, bulkPagination, isBulkFunding } = marketplaceListState;
    const fundingState = useSelector((state: RootState) => state.fundingReducer);
    const { fundingLoading, docToken, error } = fundingState;
    const limit = 10;
    const loanFlag = 'web';
    const [activeTab, setActiveTab] = useState('pinjaman');
    const [filterConfig, setFilterConfig] = useState<IInputModel[]>(BULK_MARKETPLACE_CONFIG);
    useEffect(() => {
        const payload = {
            limit,
            page: bulkPage,
        };
        dispatch(getBulkMarketplaceList(payload));
        dispatch(getLoanTypeAction());
    }, []);

    useEffect(() => {
        setFilterConfig((prev) => {
            const updated = prev.map((filter) => {
                if (filter.id === 'loanType') {
                    return { ...filter, options: loanTypeList.loanTypeList };
                }
                return filter;
            });
            return updated;
        });
    }, [loanTypeList.loanTypeList]);

    useEffect(() => {
        const payload = {
            limit,
            page,
            flag: loanFlag
        };
        dispatch(getMarketplaceListAction(payload));
    }, [page]);

    useEffect(() => {
        if (error) {
            navigate(ROUTER_PATH.afterFundingPage);
        }
    }, [error]);

    const getDataList = () => {
        const nextPage = localPagination.page + 1;
        const payload = {
            limit,
            page: nextPage,
            flag: loanFlag
        };
        dispatch(getMarketplaceListAction(payload));
    };

    const getBulkDataList = () => {
        const nextPage = localBulkPagination.page + 1;
        const payload = {
            limit,
            page: nextPage,
            flag: loanFlag
        };
        dispatch(getBulkMarketplaceList(payload));
    };

    window.onscroll = () => {
        if (Math.ceil(window.innerHeight + window.scrollY) >= document.documentElement.scrollHeight) {
            if (activeTab === 'pinjaman' && localPagination.page < pagination.totalPage) {
                if (marketplaceList.length < pagination.totalData) {
                    getDataList();
                }
            }

            if (activeTab === 'pendanaan' && localBulkPagination.page < bulkPagination.totalPage) {
                if (bulkMarketplaceList.length < bulkPagination.totalData) {
                    getBulkDataList();
                }
            }
        }
    };

    useEffect(() => {
        if (factsheetBase64) {
            const fileURL = URL.createObjectURL(factsheetBase64);
            window.open(fileURL);
            dispatch(resetMarketplaceFactsheetAction());
        }
    }, [factsheetBase64]);

    useEffect(() => {
        if (!fundingLoading && docToken !== '') {
            navigate('/privy');
        }
    }, [docToken]);

    useEffect(() => {
        let localTemp = localMarketplaceData;
        if (!loading) {
            setPagination(pagination);
            if (pagination.page === 1 || marketplaceList.length === 0) {
                localTemp = [];
            }

            if (marketplaceList.length > 0) {
                marketplaceList.forEach((each: IMarketplaceList) => {
                    const textLabel: ITextLabel[] = [
                        {
                            title: "Sisa Pendanaan",
                            value: rupiahCurrencyFormatter(each.outstandingFunding),
                            bg: false,
                            width: '11'
                        },
                        {
                            title: "Nomor Pinjaman",
                            value: each.loanNumber || '-',
                            bg: false,
                            width: '12'
                        },
                        {
                            title: "Tenor",
                            value: `${each.tenor} ${each.tenorPeriodName}` || '-',
                            bg: false,
                            width: '9.5'
                        },
                        {
                            title: "Rating",
                            value: each.grade || '-',
                            bg: false,
                            width: '7'
                        },
                        {
                            title: "Minimal Pendanaan",
                            value: rupiahCurrencyFormatter(each.minimumFunding),
                            bg: false,
                            width: '11.5'
                        },
                    ];
                    const temp: IMarketplaceTable = {
                        data: each,
                        textLabel
                    };
                    localTemp.push(temp);
                });
            }
            if (pagination.page === 1 || marketplaceList.length === 0) {
                setMarketplaceTextLabel(localTemp);
            } else {
                setMarketplaceTextLabel((prev) => {
                    const newItems = localTemp.filter((item) => !prev.some((existing) => existing.data.loanNumber === item.data.loanNumber));
                    return [...prev, ...newItems];
                });
            }
        }
    }, [marketplaceList]);

    useEffect(() => {
        if (!loading) {
            setBulkPagination(bulkPagination);

            if (bulkMarketplaceList.length === 0 || bulkPagination.page === 1) {
                setLocalBulkList([]);
            }
            if (bulkPagination.page === 1 && bulkMarketplaceList.length > 0) {
                setLocalBulkList(bulkMarketplaceList);
            } else {
                setLocalBulkList((prev) => {
                    const newItems = bulkMarketplaceList.filter((item) => !prev.some((existing) => existing.uploadId === item.uploadId));
                    return [...prev, ...newItems];
                });
            }
        }
    }, [bulkMarketplaceList]);

    useEffect(() => () => {
        dispatch(resetMarketplaceListAction());
    }, []);

    function renderTextLabel(textLabel: ITextLabel, index: number): React.ReactElement {
        return (
            <div
                className="loan-textlabel"
                key={`textLbl-${index}`}
            >
                <TextLabel
                    bg={textLabel.bg}
                    title={textLabel.title}
                    value={textLabel.value}
                    loading={textLabel.loading ? textLabel.loading : loading}
                />
            </div>
        );
    }

    function loadingMoreData(): React.ReactElement | null {
        const haveMoreData = localPagination.page + 1 <= pagination.totalPage;
        if (haveMoreData) {
            return (
                <div className="card funding-card">
                    <div className="top-container">
                        <ShimmeringLoading height={40} width={228} />
                        {marketPlaceDummyData.textLabel.map((each: ITextLabel, index: number) => (
                            renderTextLabel(each, index)
                        ))}
                    </div>
                    <div className="bottom-container loading">
                        <div className="loan-progress">
                            <FundingProgressBar
                                progressPercentage={0}
                                totalLoan={0}
                                outstandingFunding={0}
                                dueDate={0}
                                loading
                            />
                        </div>
                        <div className="button-container">
                            <ShimmeringLoading height={40} />
                        </div>
                    </div>
                </div>
            );
        }
        return null;
    }

    function renderEmptyState(): React.ReactElement | null {
        const emptyState: IEmptyState = marketplaceListEmptyState;
        if (!loading && marketplaceTextLabel.length === 0) {
            return (
                <EmptyState
                    image={emptyState.image}
                    placeholder={emptyState.placeholder}
                    caption={emptyState.caption}
                />
            );
        }

        return null;
    }

    function renderBulkEmptyState(): React.ReactElement | null {
        const emptyState: IEmptyState = marketplaceListEmptyState;
        if (localBulkList.length === 0) {
            return (
                <EmptyState
                    image={emptyState.image}
                    placeholder={emptyState.placeholder}
                    caption={emptyState.caption}
                />
            );
        }

        return null;
    }

    function renderTabComponent(): React.ReactElement {
        return (
            <div className="tab-container">
                <button
                    type="button"
                    className={`tab ${activeTab === 'pinjaman' ? 'active' : ''}`}
                    onClick={() => setActiveTab('pinjaman')}
                >
                    List Pinjaman
                </button>
                {
                    isBulkFunding && (
                        <button
                        type="button"
                        className={`tab ${activeTab === 'pendanaan' ? 'active' : ''}`}
                        onClick={() => setActiveTab('pendanaan')}
                        >
                            Pendanaan Product
                        </button>
                    )
                }
            </div>
        );
    }

    function filterOnSubmit(payload: Record<string, string | number>):void {
        const request = {
			tenor: Number(payload.tenor) || '',
            loanTypeId: Array.isArray(payload.loanType)
            ? payload.loanType.join(',')
            : payload.loanType.toString(),
			limit: 10,
			page: 1,
            flag: loanFlag
		};
        setPage(1);
        dispatch(getMarketplaceListAction(request));
    }

    function navigateToSummary(productId: string, totalLoan: string, totalLoanAmount: string, loanTypeId: string): void {
        navigate(`${ROUTER_PATH.bulkMarketplaceSummaryList}/${productId}/${totalLoan}/${totalLoanAmount}/${loanTypeId}`);
    }

    return (
		<>
			{renderTabComponent()}
			{activeTab === 'pinjaman' && (
				<div className="marketplace-list">
					{filterConfig.length > 0 &&
						filterConfig[0].options &&
						filterConfig[0].options.length > 0 && (
							<FilterBarComponent
								formField={filterConfig}
								showFilterButton
								loading={loading}
								onSubmit={(
									payload: Record<string, string | number>
								) => filterOnSubmit(payload)}
							/>
						)}
					{marketplaceTextLabel &&
						marketplaceTextLabel.map(
							(each: IMarketplaceTable, index) => (
								// eslint-disable-next-line react/no-array-index-key
								<div key={`card-${index}`}>
									<MarketplaceCard
										marketplaceTextLabel={each}
									/>
								</div>
							)
						)}
					{loadingMoreData()}
					{renderEmptyState()}
				</div>
			)}
			{activeTab === 'pendanaan' && (
				<>
					{localBulkList.map((each: IBulkMarketplaceList) => {
						// eslint-disable-next-line @typescript-eslint/no-unused-vars
						const { grade, ...rest } = each;
						return (
							// eslint-disable-next-line max-len
							// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, jsx-a11y/interactive-supports-focus
							<div
								className="pointer"
								role="button"
								key={`bulk-${each.uploadId}`}
								onClick={() => {
									navigateToSummary(
										rest.uploadId,
										rest.totalLoan.toString(),
										rupiahCurrencyFormatter(
											rest.totalLoanAmount
										),
										rest.loanTypeId
									);
								}}
							>
								<BulkFundingCard fundingData={rest} />
							</div>
						);
					})}

					{renderBulkEmptyState()}
				</>
			)}
		</>
	);
};

export default MarketplaceList;
